{
    "general": {
        "buttons": {
            "newAddress": "New address",
            "back": "Back",
            "useAddress": "Use",
            "closeModal": "Close",
            "confirmSelection": "Confirm selection",
            "addressesSelected": {
                "singular": "address selected",
                "plural": "addresses selected"
            },
            "cancel": "Cancel",
            "next": "Next",
            "addArea": "Add area"
        },
        "labels": {
            "zipcode": "ZIP code",
            "zipcodePlaceholder": "0000XX",
            "houseNumber": "House no",
            "streetName": "Street name",
            "streetNamePlaceholder": "Example street",
            "addressFound": {
                "singular": "Address found",
                "plural": "Addresses found"
            },
            "houseNumberPlaceholder": "XX",
            "radiusLabel": "Radius (m)",
            "houseValueLabel": "House value (x € 1000)",
            "filterOn": "Filter on",
            "filterRentalOption": "Rental",
            "filterSaleOption": "Sale",
            "addresses": {
                "singular": "address",
                "plural": "addresses"
            },
            "total": "Total",
            "areas": "Areas",
            "selected": "Selected",
            "houseType": "House type",
            "allTypes": "All types",
            "clearSearch": "Clear search",
            "clearSelected": "Clear selected",
            "noOptions": "No options",
            "search": "Search",
            "selectAll": "Select all",
            "selectAllFiltered": "Select all",
            "selectSomeItems": "All types",
            "create": "Create"
        },
        "houseTypes": {
            "Appartement": "Appartement",
            "Vrijstaande woning": "Detached house",
            "Tussenwoning": "Terraced house",
            "Hoekwoning": "Corner house",
            "2-onder-1-kapwoning": "Semi-detached house"
        },
        "messages": {
            "addressNotFound": {
                "singular": "No address found",
                "plural": "No addresses found"
            },
            "addressNotFoundForSelected": "No address found based on:",
            "addressesNotFoundForSelection": "No addresses found for selection",
            "generalError": "Oops! Something went wrong.",
            "addressLimitExceeded": {
                "singular": "You can only select {{max}} addresses. {{count}} address will not be selected.",
                "plural": "You can only select {{max}} addresses. {{count}} addresses will not be selected."
            },
            "addressMinimum": "Select at least {{min}} addresses to continue.",
            "zipCodeAreaLimitError": "At least {{limit}} addresses should be selected per postcode area / region. Adjust your search area by increasing the radius or adding a second area",
            "zipCodeAreaSelectionLimitError": "At least {{limit}} addresses should be selected per postcode area / region."
        }
    },
    "slideInPanel": {
        "header": {
            "title": "Addresses"
        },
        "tableColumnLabels": {
            "streetName": "Street name",
            "amountName": "Amount",
            "zipCodeArea": "Zipcode area"
        },
        "content": {
            "noSelection": "Please select some addresses in the previous step"
        }
    },
    "summary": {
        "header": {
            "title": "Summary"
        }
    },
    "filters": {
        "buttons": {
            "showMore": "Show more filters",
            "showLess": "Show less filters"
        },
        "household": {
            "label": "Household",
            "singles": "Single",
            "families": "Families",
            "familiesWithSmallChildren": "Families with small children ≤3 Jaar"
        },
        "buildingType": {
            "label": "Building type",
            "appartment": "Appartement",
            "midTerraceHouse": "Mid terrace house",
            "detachedHouse": "Detached house",
            "terraceHouse": "Terrace house",
            "doubleHouse": "Double house",
            "smallBlockFlat": "Small block flat",
            "largeBlockFlat": "Large block flat",
            "highRiseBuilding": "High-rise building",
            "cornerHouse": "Corner house"
        },
        "buildingUsage": {
            "label": "Building usage",
            "unknown": "Unknown",
            "residential": "Residential",
            "mixedUse": "Mixed use",
            "commercial": "Commercial"
        },
        "buyRatio": {
            "label": "Filter on ownership rate"
        },
        "buildYear": {
            "label": "Filter on build year"
        },
        "livingArea": {
            "label": "Filter on living Area"
        },
        "scaleText": {
            "extremeLow": "Extremly low",
            "veryLow": "Very low",
            "low": "Low",
            "medium": "Medium",
            "middleHigh": "Medium high",
            "high": "High",
            "veryHigh": "Very high",
            "extremeHigh": "Extremly high"
        },
        "residenceLength": {
            "label": "Filter on residence length",
            "lessThanOneYear": "up to 1 Year",
            "betweenOneAndTwoYears": "up to  2 Years",
            "betweenTwoAndThreeYears": "up to  3 Years",
            "betweenThreeAndFourYears": "up to  4 Years",
            "betweenFourAndFiveYears": "up to  5 Years",
            "betweenFiveAndSixYears": "up to  6 Years",
            "betweenSixAndEightYears": "up to  8 Years",
            "betweenEightAndTenYears": "up to  10 Years",
            "moreThanTenYears": "more then 10 Years"
        },
        "purchasingPowerClass": {
            "label": "Filter by purchasing power class",
            "farBelowAverage": "Far below average",
            "belowAverage": "Below average",
            "lowerAverage": "Lower average",
            "average": "Average",
            "upperAverage": "Upper average",
            "aboveAverage": "Above average",
            "farAboveAverage": "Far above average"
        }
    }
}